import { render, staticRenderFns } from "./DocumentNotes.vue?vue&type=template&id=4f667408&scoped=true"
import script from "./DocumentNotes.vue?vue&type=script&lang=js"
export * from "./DocumentNotes.vue?vue&type=script&lang=js"
import style0 from "./DocumentNotes.vue?vue&type=style&index=0&id=4f667408&prod&lang=scss&scoped=true"
import style1 from "./DocumentNotes.vue?vue&type=style&index=1&id=4f667408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f667408",
  null
  
)

export default component.exports